export default __webpack_public_path__ + "static/media/svg.7c539015.svg";